/**
 * Shared page header for Marketer View destinations (SYR-68, Phase E).
 * Big title + muted subtitle, matching the hand-off's per-destination heads.
 */

import React from 'react';
import { THEME } from '../config/theme';

export interface MarketerPageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Optional right-aligned actions (filters, toggles). */
  actions?: React.ReactNode;
}

export const MarketerPageHeader: React.FunctionComponent<MarketerPageHeaderProps> = ({
  title,
  subtitle,
  actions,
}) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 16,
      marginBottom: 20,
      flexWrap: 'wrap',
    }}
  >
    <div>
      <h1
        style={{
          fontSize: 30,
          fontWeight: 700,
          color: THEME.textBase,
          letterSpacing: '-0.02em',
          margin: 0,
          lineHeight: 1.12,
        }}
      >
        {title}
      </h1>
      {subtitle && (
        <p
          style={{
            fontSize: 15.5,
            lineHeight: 1.6,
            color: THEME.textSecondary,
            margin: '8px 0 0',
            maxWidth: 720,
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
    {/* The slot may shrink and its contents wrap: a long row of tags and
        buttons must fold onto new lines, never push the page sideways. */}
    {actions && <div style={{ flex: '0 1 auto', minWidth: 0 }}>{actions}</div>}
  </div>
);
